export default function RecipeDetail({ recipe, onClose, onEdit, onDelete }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 600 }}>
        <div className="modal-header">
          <h3 style={{ fontSize: 14, color: 'var(--ice)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '80%' }}>
            {recipe.name}
          </h3>
          <button className="btn btn-ghost btn-icon btn-sm" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body" style={{ padding: 0 }}>
          {/* Photo */}
          {recipe.image_url && (
            <img
              src={recipe.image_url}
              alt={recipe.name}
              style={{ width: '100%', maxHeight: 240, objectFit: 'cover', display: 'block' }}
            />
          )}

          <div style={{ padding: '16px' }}>
            {/* Rating */}
            {recipe.rating > 0 && (
              <div style={{ marginBottom: 12 }}>
                {[1,2,3,4,5].map(s => (
                  <span key={s} style={{ fontSize: 20, color: s <= recipe.rating ? 'var(--warn)' : 'var(--border2)' }}>★</span>
                ))}
              </div>
            )}

            {/* Categories */}
            {recipe.categories?.length > 0 && (
              <div className="recipe-cat-row" style={{ marginBottom: 14 }}>
                {recipe.categories.map(c => (
                  <span key={c.id} className="recipe-cat-tag">{c.name}</span>
                ))}
              </div>
            )}

            {/* Meta */}
            {(recipe.prep_time > 0 || recipe.cook_time > 0 || recipe.servings > 0) && (
              <div className="recipe-detail-meta">
                {recipe.prep_time > 0 && (
                  <div className="recipe-meta-item">
                    <span className="recipe-meta-icon">⏱</span>
                    <span className="recipe-meta-label">Voorbereid.</span>
                    <span className="recipe-meta-val">{recipe.prep_time} min</span>
                  </div>
                )}
                {recipe.cook_time > 0 && (
                  <div className="recipe-meta-item">
                    <span className="recipe-meta-icon">🔥</span>
                    <span className="recipe-meta-label">Kooktijd</span>
                    <span className="recipe-meta-val">{recipe.cook_time} min</span>
                  </div>
                )}
                {recipe.servings > 0 && (
                  <div className="recipe-meta-item">
                    <span className="recipe-meta-icon">👥</span>
                    <span className="recipe-meta-label">Porties</span>
                    <span className="recipe-meta-val">{recipe.servings}</span>
                  </div>
                )}
              </div>
            )}

            {/* Ingredients */}
            {recipe.ingredients?.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <h4 className="recipe-section-title">Ingrediënten</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  {recipe.ingredients.map((ing, i) => (
                    <div key={i} className="ingredient-display-row">
                      <span className="ingredient-qty">
                        {ing.quantity && `${ing.quantity} `}{ing.unit}
                      </span>
                      <span className="ingredient-name">{ing.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Steps */}
            {recipe.steps?.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <h4 className="recipe-section-title">Bereiding</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {recipe.steps.map((step, i) => (
                    <div key={i} className="step-display-row">
                      <div className="step-number">{i + 1}</div>
                      <div className="step-description">{step.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Notes */}
            {recipe.notes && (
              <div style={{ marginBottom: 16 }}>
                <h4 className="recipe-section-title">Notities</h4>
                <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{recipe.notes}</p>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-danger btn-sm" onClick={() => onDelete(recipe.id)}>🗑 Verwijderen</button>
          <div style={{ flex: 1 }} />
          <button className="btn btn-ghost" onClick={onClose}>Sluiten</button>
          <button className="btn btn-primary" onClick={() => onEdit(recipe)}>✏️ Bewerken</button>
        </div>
      </div>
    </div>
  );
}
